import axios from "axios";
import queryString from "query-string";
import store from "../store";
import Vue from "vue";

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    let token = null;
    if (store.state && store.state.user) {
      token = store.state.user.token;
    } else if (store.state.token) {
      token = store.state.token;
    }
    config.headers.set
      ? config.headers.set(
          "Authorization",
          token || window.$cookies.get("token")
        )
      : (config.headers["Authorization"] =
          token || window.$cookies.get("token"));
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export function HttpServiceV2(endpoint) {
  const BASE = process.env.VUE_APP_BASE_URL_V2;
  this.url = `${BASE}${endpoint}`;
  this.get = async function (id, query) {
    if (!query) {
      query = {};
    }
    if (id) {
      return axios.get(`${this.url}/${id}`);
    }
    if (query) {
      const str = queryString.stringify(query);
      return axios.get(`${this.url}?${str}`);
    }
    return axios.get(this.url);
  };
}

export default function HttpService(endpoint) {
  const BASE = process.env.VUE_APP_BASE_URL;
  this.url = `${BASE}${endpoint}`;
  this.get = async function (id, query) {
    if (!query) {
      query = {};
    }
    if (!query.sort) {
      query.sort = "ascending";
    }
    if (!query.field) {
      query.field = "name";
    }
    if (id) {
      return axios.get(`${this.url}/${id}`);
    }
    if (query) {
      const str = queryString.stringify(query);
      return axios.get(`${this.url}?${str}`);
    }
    return axios.get(this.url);
  };
  this.post = async function (body = {}, endpoint) {
    Vue.$log.debug("MAKE POST");
    const url = endpoint ? `${this.url}/${endpoint}` : this.url;
    return axios.post(url, body);
  };
  this.postBatch = async function (body = []) {
    Vue.$log.debug("MAKE POST");
    return axios.post(`${this.url}/batch`, body);
  };
  this.put = async function (body = {}, id = null, config = {}) {
    if (id) {
      return axios.put(`${this.url}/${id}`, body, config);
    }
    return axios.put(this.url, body, config);
  };
  this.delete = async function (id) {
    if (!id) {
      return axios.delete(this.url);
    }
    const deleteUrl = `${this.url}/${id}`;
    Vue.$log.debug("Delete url", deleteUrl);
    return axios.delete(deleteUrl);
  };
  this.patch = async function (body = {}) {
    return axios.patch(this.url, body);
  };
}
